import type { QuickResponsePayload, QuickResponseProperties } from '../types/models';

export default class QuickResponse implements QuickResponseProperties {
  text: string;
  buttonId: string | null;
  open: string;
  type: string;
  url: string;

  constructor(payload: QuickResponsePayload) {
      this.text = payload.text || '';
      this.buttonId = payload.buttonId || null;
      this.open = payload.open || ''; 
      this.type = payload.type || '';
      this.url = payload.url || '';
    }
  }
  